import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

let req_url, img_req_url
if (process.env.NODE_ENV == 'development') {
  req_url = '/api'
  img_req_url = 'http://image-cdn-test.vbdata.cn'
} else {
  if (process.env.VUE_APP_FLAG === 'pro') {
    // 生产环境
    if (window.location.protocol == 'http:') {
      req_url = 'http://vb100-list-api.vcbeat.top'
    } else {
      req_url = 'https://vb100-list-api.vcbeat.top'
    }
    img_req_url = 'https://cdn.vbdata.cn'
  } else {
    // 测试环境
    if (window.location.protocol == 'http:') {
      req_url = 'http://t-vb100-list-api.vcbeat.top'
      img_req_url = 'http://image-cdn-test.vbdata.cn'
    } else {
      req_url = 'https://t-vb100-list-api.vcbeat.top'
      img_req_url = 'https://image-cdn-test.vbdata.cn'
    }
  }
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"
  ]
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break
    }
  }
  return flag
}

const store = new Vuex.Store({
  state: {
    req_url: req_url,
    img_req_url: img_req_url,

    is_pc: IsPC(),
    list_meta: '' , //榜单元数据
    entity_keys: ['公司名称','公司简称','企业名称','企业简称','机构名称','机构简称','园区名称','园区简称','园区','产业园','产业园区'],
    time_keys: ['成立时间'],
    address_keys: ['所在地区', '地区', '所在地域', '国家'],
    round_keys: ['轮次', '融资轮次', '最新轮次', '最新融资轮次', '当前轮次', '最近一轮融资轮次']
  },
  mutations: {
    getMeta(state, values) {
      state.list_meta = values
    }
  },
  actions: {
    // getMeta({ commit }) {
    //   axios.post(this.state.req_url + '/meta/getMeta', {}).then(res => {
    //     commit('getMeta', res.data)
    //   })
    // },
  },
  modules: {}
})
// store.dispatch('getMeta')
export default store
